import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { SessionStorageService, SessionStorage } from '../jng2-webstorage/app';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators/map';

import { ConfigService } from '../config/config.service';

@Injectable()
export class NotificationService {

    constructor(private http: HttpClient, private configService: ConfigService) {

    }

    // #region Get Notifications Service Call

    GetNotifications(AuthToken: string, CurrentRole: string) {
        return this.http.get<NotificationsInfo>(this.configService.hostAddress + `Api/Services/DELTA/GetNotifications?AuthToken=${AuthToken || ''}&AsRole=${CurrentRole || ''}`)
            .pipe(
                map(res => {
                    let body = res;

                    if (body) {
                        body.LastLogin = (body.LastLogin ? new Date(body.LastLogin) : null);

                        if (body.Notices && body.Notices.length) {
                            body.Notices.forEach(item => {
                                if (item.Details && item.Details.length) {
                                    item.Details.forEach(detail => {
                                        detail.DateUpdated = (detail.DateUpdated ? new Date(detail.DateUpdated) : null);
                                    });
                                }
                            });
                        }

                        if (body.AdoptionRequests && body.AdoptionRequests.length) {
                            body.AdoptionRequests.forEach(item => {
                                if (item.Details && item.Details.length) {
                                    item.Details.forEach(detail => {
                                        detail.DateUpdated = (detail.DateUpdated ? new Date(detail.DateUpdated) : null);
                                    });
                                }
                            });
                        }
                    }

                    return body;
                })
            );
    }

    // #endregion
    
}

// #region Custom Classes

// #region Notification Item Class

        export class NotificationItem {
            Message: string;
            SortOrder: number;
            LinkState: string;
            Details: NotificationTermInfo[];
            IconName: string;
        }

    // #endregion

    // #region Notifications Info Class

        export class NotificationsInfo {
            LastLogin?: Date;
            Notices?: NotificationItem[];
            ClassicNotification?: boolean;
            StudentCount?: number;
            AdoptionRequests?: NotificationItem[];
        }

    // #endregion

    // #region Notification Term Info Class

        export class NotificationTermInfo {
            DualEnrollStudentID?:number;
            StudentID?: string;
            StudentName?: string;
            SchoolYear?: string;
            Term?: string;
            DateUpdated?: Date;
            CollegeID?: number;
            CollegeName?: string;
            ActionItemID?: number;
            ActionItemName?: string;
            FormStatus?: number;
            SchoolName?: string;
        }

    // #endregion

// #endregion


// WEBPACK FOOTER //
// ./src/services/notification/notification.service.ts